export default "__VITE_ASSET__CdOSA7k3__"